import { render, staticRenderFns } from "./DeviceAuthority.vue?vue&type=template&id=b5dbf6c8&scoped=true&"
import script from "./DeviceAuthority.vue?vue&type=script&lang=js&"
export * from "./DeviceAuthority.vue?vue&type=script&lang=js&"
import style0 from "./DeviceAuthority.vue?vue&type=style&index=0&id=b5dbf6c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5dbf6c8",
  null
  
)

export default component.exports